<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <mat-select [(ngModel)]="selectedItemsList" (selectionChange)="change()" multiple>
    @if (!isListValuesEmpty()) {
      <mat-checkbox (change)="toggleSelectAllValues()"
      [checked]="isSelectAll()" class="select-all-checkbox">Select All</mat-checkbox>
    }
    @for (item of itemsList; track item) {
      <mat-option [value]="item.id">
        {{ item.value }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>